import React, { PropsWithChildren, useContext, useEffect, useState } from 'react';

interface IPartnerContext {
  partnerIdentifier: string;
  setPartnerIdentifier: (_: string) => void;
}

const PartnerContext = React.createContext<IPartnerContext>({
  partnerIdentifier: '',
  setPartnerIdentifier: () => {},
});

export const PartnerContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [partnerIdentifier, setPartnerIdentifier] = useState<string>('');

  return (
    <PartnerContext.Provider
      value={{
        partnerIdentifier,
        setPartnerIdentifier,
      }}
    >
      {children}
    </PartnerContext.Provider>
  );
};

export const UpdatePartnerIdentifier: React.FC<{ identifier: string }> = ({ identifier }) => {
  const partnerContext = useContext(PartnerContext);

  useEffect(() => {
    if (identifier) {
      partnerContext?.setPartnerIdentifier(identifier);
    }
  }, [identifier, partnerContext]);

  return null;
};
